import { PlanTypes, CommonTypes } from "../../../interfaces";
import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants";
import { CMSTypes } from "../../../interfaces";

export const tabList = (): Promise<PlanTypes.HomeTabResponse> => {
  return axios.get(API_ROUTES.HOME_TABS.LIST);
}

export const updateTabList = (tabId: string, payload: PlanTypes.UpdateHomeTabPayload): Promise<CommonTypes.DefaultResponse> => {
  return axios.put(`${API_ROUTES.HOME_TABS.LIST}/${tabId}`, payload);
}

export const getPlans = (query: PlanTypes.PlanListQuery): Promise<PlanTypes.PlanListResponse> => {
  return axios.get(API_ROUTES.PLANS.LIST, { params: query });
}

export const updatePlan = (payload: any, planId: string): Promise<any> => {
  return axios.put(`${API_ROUTES.PLANS.UPDATE}/${planId}`, payload);
}

export const updatePlanDetails = (payload: PlanTypes.PlanDetailsUpdatePayload): Promise<CommonTypes.DefaultResponse> => {
  return axios.put(`${API_ROUTES.PLANS.UPDATE}`, payload);
}

export const getCountryRegionsPlanDetails = (query: PlanTypes.CountryRegionsPlanDetailsQuery): Promise<PlanTypes.PlanDetailsResponse> => {
  return axios.get(`${API_ROUTES.PLANS.DETAILS}`, { params: query });
}

export const popularCountriesUpdate = (payload: PlanTypes.UpdatePopularCountriesPayload): Promise<CommonTypes.DefaultResponse> => {
  return axios.put(API_ROUTES.COUNTRIES.POPULAR_COUNTRIES_UPDATE, payload);
}

export const updatePopularCountries = (payload: PlanTypes.UpdatePopularCountriesPayload): Promise<CommonTypes.DefaultResponse> => {
  return axios.put(API_ROUTES.COUNTRIES.UPDATE_POPULAR_COUNTRIES, payload);
}

export const getGeoCounries = (params: any): Promise<any> => {
  return axios.get(`/regions/countries`, { params});
}
export const putGeoCounries = (params: any): Promise<any> => {
  return axios.put(`/regions/countries`, params);
}

export const getGeoRegions = (params: any): Promise<any> => {
  return axios.get(`/regions`, { params});
}

export const putGeoRegions = (params: any): Promise<any> => {
  return axios.put(`/regions/updateRegion`, params);
}
export const addCMSCountry = (params: any): Promise<any> => {
  return axios.post(`/admin/cms/country`, {...params,partnerWebsiteId:["667000f74e37cd362882386e","67dbb587b651973c9b130b18"]});
}

export const updateCountryBlogs = (params: any): Promise<any> => {
  return axios.patch(`/admin/cms/blog`, params);
}
export const getAllCMSCountry = (params: any): Promise<any> => {
  return axios.get(`/admin/cms`, { params});
}
export const updateCountrySEO = (params: any): Promise<any> => {
  return axios.patch(`/admin/cms/seo`, params);
}
export const deleteCountryFaq = (cmsId: string,faqIndex:string): Promise<any> => {
  return axios.delete(`/admin/cms/${cmsId}/faq/${faqIndex}`);
}
export const deleteCountryBlog = (cmsId: string,blogIndex:string): Promise<any> => {
  return axios.delete(`/admin/cms/${cmsId}/blog/${blogIndex}`);
}
export const deleteCountryInsta = (cmsId: string,instaIndex:string): Promise<any> => {
  return axios.delete(`/admin/cms/${cmsId}/insta-link/${instaIndex}`);
}

export const updateCountryFAQ = (params: any): Promise<any> => {
  return axios.patch(`/admin/cms/faq`, params);
}
export const updateCountryInsta = (params: any): Promise<any> => {
  return axios.patch(`/admin/cms/insta-link`, params);
}
export const getSortingCountryList = (countryId?: string): Promise<any> => {
  const url = countryId 
    ? `country-attachments/country/${countryId}` 
    : `country-attachments/country/default`;

  return axios.get(url);
};
export const addCountryFromSelect = (params: { 
  countryId: string | null; 
  isDefault: boolean; 
  iso: string; 
  attachedCountries: { countryId: string }[];  
}): Promise<any> => {
  return axios.post(`country-attachments`, {
    ...params,
    countryId: params.countryId ?? null, // Ensure `null` is explicitly sent if countryId is missing
  });
};


export const updateCountryFromDragDrop = (
  regionId: string | null,
  attachedCountries: { countryId: string; sortNumber: number }[]
): Promise<any> => {
  const id = regionId ?? "default"; // Use "null" or another placeholder if regionId is not provided

  return axios.put(`/country-attachments/${id}/sort-order`, { attachedCountries });
};


export const deleteCountryFromDragDrop = (
  countryId: string | null,
  countryToDeleteId: string
): Promise<any> => {
  const id = countryId ?? "default"; // Use "null" or another placeholder if countryId is not provided

  return axios.delete(`/country-attachments/${id}/detach/${countryToDeleteId}`);
};



export const list = (params: CMSTypes.ListCMSQuery): Promise<CMSTypes.ListCMSResponse> => {
  return axios.get(API_ROUTES.CMS.LIST, { params });
}

export const update = (payload: CMSTypes.UpdateCMSPayload): Promise<CMSTypes.ListCMSResponse> => {
  return axios.patch(API_ROUTES.CMS.LIST, payload);
}

export const listFAQs = (query?: CMSTypes.ListFAQQuery): Promise<CMSTypes.FAQListResponse> => {
  return axios.get(API_ROUTES.FAQ.LIST, { params: query });
}

export const createFAQ = (payload: CMSTypes.CreateFAQPayload): Promise<CMSTypes.FAQListResponse> => {
  return axios.post(API_ROUTES.FAQ.LIST, payload);
}

export const updateFAQ = (payload: CMSTypes.UpdateFAQPayload): Promise<CMSTypes.FAQListResponse> => {
  return axios.patch(API_ROUTES.FAQ.LIST, payload);
}

export const removeFAQ = (id: string): Promise<CMSTypes.FAQListResponse> => {
  return axios.delete(`${API_ROUTES.FAQ.LIST}/${id}`);
}

export const listTroubleShoot = (query?: CMSTypes.ListFAQQuery): Promise<CMSTypes.FAQListResponse> => {
  return axios.get(API_ROUTES.TROUBLESHOOT.LIST, { params: query });
}

export const createTroubleShoot= (payload: CMSTypes.CreateFAQPayload): Promise<CMSTypes.FAQListResponse> => {
  return axios.post(API_ROUTES.TROUBLESHOOT.LIST, payload);
}
export const updateTroubleShoot = (payload: CMSTypes.UpdateTroubleShootPayload): Promise<CMSTypes.FAQListResponse> => {
  return axios.patch(API_ROUTES.TROUBLESHOOT.LIST, payload);
}

export const removeTroubleShoot = (id: string): Promise<CMSTypes.FAQListResponse> => {
  return axios.delete(`${API_ROUTES.TROUBLESHOOT.LIST}/${id}`);
}
export const addBanner = (payload: any): Promise<any> => {
  return axios.post(`/banner/add`, payload);
}
export const deleteBanner = (countryId: string,bannerImage:string,bannerImageWebId:string): Promise<any> => {
  return axios.post(`/banner/delete`,{countryId,bannerImage,bannerImageWebId});
}


